import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Files } from '../../../models/agents/files';
import swal from 'sweetalert2';
import { ImageViewerConfig } from 'ngx-image-viewer';
import { imageViewerOptions } from '../../../../assets/image-viewer-options';
import { NgxDocViewerComponent } from 'ngx-doc-viewer';
import { Store } from '@ngxs/store';
import {
  DisableCompanyFile,
  UpdateCompanyFilesOnServer,
  AddCompanyFiles,
  UpdateCompanyFiles
} from '../../../state-manager/actions/company-register.action';
import { ModalBasicComponent } from '../../shared/modal-basic/modal-basic.component';
import { FileUploaderComponent } from '../../shared/file-uploader/file-uploader.component';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PersonService } from '../../../services/person.service';
import { CompanyService } from '../../../services/company.service';
import { AgentFullRegistration } from '../../../models/agents/agent-full-registration';
import {
  DisablePersonFile,
  UpdatePersonFilesOnServer,
  AddPersonFiles
} from '../../../state-manager/actions/person-register.action';
import { cloneDeep, chain } from 'lodash';
import { UploadCompanyCategoryType } from '../../../models/enums/upload-category-type-enum';
import { DxDateBoxComponent } from 'devextreme-angular';
import { HttpClient } from '@angular/common/http';
import { locale } from 'devextreme/localization';
import 'devextreme-intl';
import { custom } from 'devextreme/ui/dialog';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';
import { InvestorFileTypes } from '../../../models/enums/investor-file-types.enum';
import * as moment from 'moment-timezone';
import { MixpanelService } from '../../../services/mix-panel.service';
import { DateService } from '../../../services/date.service';
import { ObjectHelper } from '../../../helpers/object-helper';
import { SelectDynamic } from '../../../models/agents/dynamic-select-list';

@Component({
  selector: 'app-card-editable-list-documents',
  templateUrl: './card-editable-list-documents.component.html',
  styleUrls: ['./card-editable-list-documents.component.scss']
})
export class CardEditableListDocumentsComponent implements OnInit {
  @Input() files: Array<Files> = null;
  @Input() registration: AgentFullRegistration;

  @Input() tipo: 'PF' | 'PJ';
  @Input() loading = false;

  @ViewChild('uploadModal') uploadModal: ModalBasicComponent;
  @ViewChild('dateField') dateField: DxDateBoxComponent;
  @ViewChild('fileUploader') fileUploader: FileUploaderComponent;

  filterargs = { isDeleted: false };
  formGroupFile: FormGroup;
  formGroupUpload: FormGroup;
  filesModal: Array<Files>;
  fileDescription: Array<{}>;
  isFile: boolean;
  filesGropedByType: [string, any][] = [];
  uploadedFiles: Array<Files> = new Array<Files>();
  missingRequiredFields: { date: boolean; documentType: boolean } = {
    date: false,
    documentType: false
  };
  filesBackup: Array<Files>;
  get uploadCategoryTypeEnum() {
    return this.tipo === 'PJ'
      ? this.uploadCategoryType
      : this.investorCategoryType;
  }

  investorCategoryType: Array<SelectDynamic>;
  uploadCategoryType: Array<SelectDynamic>;
  // Image Viewer Configurator
  imageSrc = [];
  imageIndex = 0;
  config: ImageViewerConfig = imageViewerOptions;
  ngxDocComponent: NgxDocViewerComponent;

  // Document Viewer Configuration
  docSrc: string;

  constructor(
    private http: HttpClient,
    protected store: Store,
    protected formBuilder: FormBuilder,
    protected personService: PersonService,
    protected companyService: CompanyService,
    private mixpanel: MixpanelService,
    protected dateService: DateService
  ) {
    locale(navigator.language);
    this.initFormGroupKeyOptions();
    this.loadingUploadCategoryType();
    this.loadingInvestorCategoryType();
  }

  loadingUploadCategoryType() {
    const objectHelper = new ObjectHelper();
    this.uploadCategoryType = objectHelper.EnumToListWithoutFilter(
      UploadCompanyCategoryType
    );
    this.uploadCategoryType = this.uploadCategoryType.sort((a, b) =>
      a.value.localeCompare(b.value)
    );
    this.uploadCategoryType = objectHelper.SelectDynamicToAlphabeticOrder(
      this.uploadCategoryType
    );
  }

  loadingInvestorCategoryType() {
    const objectHelper = new ObjectHelper();
    this.investorCategoryType = objectHelper.EnumToListWithoutFilter(
      InvestorFileTypes
    );
    this.investorCategoryType = this.investorCategoryType.sort((a, b) =>
      a.value.localeCompare(b.value)
    );
    this.investorCategoryType = objectHelper.SelectDynamicToAlphabeticOrder(
      this.investorCategoryType
    );
  }

  ngOnInit() {
    if (this.files) {
      this.modifyFileUrl();
      this.files = this.files.filter((fl) => fl.isDeleted === false);
      this.filesBackup = cloneDeep(this.files);
      this.groupBy();
    }
    this.initFormGroupUpload();
  }

  modifyFileUrl() {
    const arrayFiles = new Array<Files>();
    this.files.forEach((files) => {
      arrayFiles.push(new Files(files));
    });

    this.files = arrayFiles;
  }

  formatDocumentDate(date: string): string {
    return moment.parseZone(date).format('DD/MM/YYYY');
  }

  ngOnChanges() {
    if (this.files) {
      this.modifyFileUrl();
      this.files = this.files.filter((fl) => fl.isDeleted === false);
      this.filesBackup = cloneDeep(this.files);

      this.groupBy();
      this.imageSrc = this.files.map((file) => file.fileUrl);
    }
  }

  initFormGroupUpload() {
    this.formGroupUpload = this.formBuilder.group({
      date: this.formBuilder.control('', Validators.required),
      documentType: this.formBuilder.control('', Validators.required)
    });
  }

  closeModal() {
    document
      .querySelector('#modal-file-documentos')
      .classList.remove('md-show');
  }

  getFileIcon(file: Files) {
    const extension = file.fileName.split('.').pop().toLowerCase();

    if (
      extension === 'jpeg' ||
      extension === 'jpg' ||
      extension === 'bmp' ||
      extension === 'gif' ||
      extension === 'png'
    ) {
      return 'image';
    } else if (extension === 'doc') {
      return 'insert_drive_file';
    } else if (extension === 'pdf') {
      return 'picture_as_pdf';
    } else {
      return 'insert_drive_file';
    }
  }

  disableFile(file: Files) {
    const index = this.files.indexOf(file);
    this.files.splice(index, 1);
    const tipo = this.tipo;
    if (tipo === 'PF') {
      this.store.dispatch(new DisablePersonFile(file));
    } else if (tipo === 'PJ') {
      this.store.dispatch(new DisableCompanyFile(file));
    }
  }

  initFormGroupKeyOptions() {
    this.formGroupFile = this.formBuilder.group({
      fileUrl: this.formBuilder.control(false),
      fileName: this.formBuilder.control(false),
      fileType: this.formBuilder.control(false),
      isDeleted: this.formBuilder.control(false)
    });
  }

  onUploadFile(e: {
    item: any;
    response: any;
    status: any;
    headers: any;
  }): void {
    if (e.response.invalid) {
      swal({
        title: 'Dados de Cadastro!',
        text: 'Você inseriu uma data futura ou invalida.',
        type: 'warning'
      }).catch(swal.noop);
    } else if (e.item.isSuccess) {
      const jsonResponse = JSON.parse(e.response);
      const file: Files = {
        fileName: jsonResponse.documentName,
        fileType: jsonResponse.documentType,
        isDeleted: jsonResponse.documentIsDeleted,
        documentDate: jsonResponse.documentDate
      };
      this.uploadedFiles.push(new Files(file));
    } else if (e.response.missing && e.response.missing.length) {
      e.response.missing.forEach(
        (field) => (this.missingRequiredFields[field] = true)
      );
    }
  }

  getTypeValue(type: UploadCompanyCategoryType | InvestorFileTypes): string {
    if (!type) {
      return null;
    }

    return this.tipo === 'PJ'
      ? UploadCompanyCategoryType[type]
      : InvestorFileTypes[type];
  }

  onConfirmUpload() {
    this.mixpanel.track('Visualizar - Upload de documentos');

    if (!this.dateService.isValid(this.formGroupUpload.get('date').value)) {
      swal({
        title: 'Dados de Cadastro!',
        text: 'Você inseriu uma data invalida.',
        type: 'warning'
      }).catch(swal.noop);
      return;
    }

    if (this.dateService.isFuture(this.formGroupUpload.get('date').value)) {
      swal({
        title: 'Dados de Cadastro!',
        text: 'Você inseriu uma data futura.',
        type: 'warning'
      }).catch(swal.noop);
      return;
    }

    this.store.dispatch(
      this.tipo === 'PJ'
        ? new AddCompanyFiles(this.uploadedFiles)
        : new AddPersonFiles(this.uploadedFiles)
    );
    this.uploadedFiles = [];
    this.fileUploader.files = [];
  }

  checkRequiredFields(formControlName: string) {
    if (!this.formGroupUpload.get(formControlName).valid) {
      this.missingRequiredFields[formControlName] = true;
    } else {
      this.missingRequiredFields[formControlName] = false;
    }
  }

  onChange(fileType: string, fileName: string): void {
    const file = this.files.filter((file) => {
      return file.fileName === fileName;
    });

    const listFiles = this.files.filter((fl) => {
      return fl.fileName !== fileName;
    });

    const data: Files = {
      fileUrl: file[0].fileUrl,
      fileName: fileName,
      fileType: fileType,
      isDeleted: file[0].isDeleted
    };

    listFiles.push(new Files(data));

    // Atualizar arquivos da empresa
    if (this.registration.company) {
      this.store
        .dispatch(new UpdateCompanyFiles(listFiles))
        .pipe(first())
        .subscribe(
          () => {
            this.loading = false;
            swal({
              title: 'Opções Compliance',
              text: 'Cadastro atualizado com sucesso.',
              type: 'success'
            }).catch(swal.noop);

            this.files = listFiles;
          },
          () => {
            swal({
              title: 'Opções Compliance',
              text:
                'Houve um erro ao atualizar o cadastro. Tente novamente mais tarde.',
              type: 'error'
            }).catch(swal.noop);
          }
        );
    }

    // Atualizar arquivos da pessoa
    if (this.registration.person) {
      // this.store.dispatch(new UpdatePersonFilesOnServer(this.registration.agent.id,listFiles));
      this.personService
        .updateFiles(this.registration.agent.id, listFiles)
        .subscribe(
          () => {
            this.loading = false;
            swal({
              title: 'Opções Compliance',
              text: 'Cadastro atualizado com sucesso.',
              type: 'success'
            }).catch(swal.noop);

            this.files = listFiles;
          },
          () => {
            swal({
              title: 'Opções Compliance',
              text:
                'Houve um erro ao atualizar o cadastro. Tente novamente mais tarde.',
              type: 'error'
            }).catch(swal.noop);
          }
        );
    }
  }

  openOrCloseModal() {
    if (this.uploadModal.visible) {
      this.uploadModal.hide();
    } else {
      this.uploadModal.show();
    }
  }

  private groupBy(restoreFiles: boolean = false) {
    if (restoreFiles) {
      this.files = cloneDeep(this.filesBackup);
      this.files = this.files.filter((fl) => fl.isDeleted === false);
    }

    this.filesGropedByType = chain(this.files)
      .groupBy('fileType')
      .map((value: string, key: Files[]) => ({ fileType: key, files: value }))
      .value();
  }

  private createConfirmationModal({
    title,
    messageHtml,
    confirmationFunction,
    negationFunction
  }) {
    const confirmDialog = custom({
      title,
      messageHtml,
      buttons: [
        {
          text: 'Não',
          onClick: (e) => false
        },
        {
          text: 'Sim',
          onClick: (e) => true
        }
      ]
    });

    confirmDialog.show().then((confirm) => {
      if (confirm) {
        if (confirmationFunction) {
          confirmationFunction();
        }
      } else {
        if (negationFunction) {
          negationFunction();
        }
      }
    });
  }

  onRemoveDocumentFromList(fileUrl) {
    this.createConfirmationModal({
      title: 'Você tem certeza?',
      messageHtml: 'Você realmente deseja excluir esse documento?',
      confirmationFunction: () => {
        this.files = this.files.filter((args) => args.fileUrl !== fileUrl);
        this.groupBy();
      },
      negationFunction: () => { }
    });
  }

  onCancelEdit() {
    this.createConfirmationModal({
      title: 'Você tem certeza?',
      messageHtml: 'Você realmente deseja cancelar a edição dos documentos?',
      confirmationFunction: () => {
        this.groupBy(true);
        this.openOrCloseModal();
      },
      negationFunction: () => { }
    });
  }

  onSaveChanges() {
    this.createConfirmationModal({
      title: 'Você tem certeza?',
      messageHtml: 'Você realmente deseja salvar os documento?',
      confirmationFunction: () => {
        this.filesBackup = cloneDeep(this.files);

        let observable: Observable<Object>;

        if (this.registration.company) {
          observable = this.companyService.updateFiles(
            this.registration.agent.id,
            this.files
          );
        } else {
          observable = this.personService.updateFiles(
            this.registration.agent.id,
            this.files
          );
        }

        observable.subscribe(
          () => {
            this.loading = false;
            swal({
              title: 'Documentos',
              text: 'Documentos atualizados com sucesso.',
              type: 'success'
            }).catch(swal.noop);
          },
          () => {
            swal({
              title: 'Documentos',
              text:
                'Houve um erro ao atualizar os documentos. Tente novamente mais tarde.',
              type: 'error'
            }).catch(swal.noop);
          }
        );

        /*if (this.registration.person) {
          this.store.dispatch(new AddPersonFiles(this.files));
        } else if (this.registration.company) {
          this.store.dispatch(new AddCompanyFiles(this.files));
        }*/

        this.openOrCloseModal();
      },
      negationFunction: () => { }
    });
  }

  downloadFile(file: Files) {
    this.loading = true;
    this.personService.downloadInvestorFile(file).subscribe(result => {
      const blob = new Blob([result], { type: result.type });

      const downloadURL = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadURL;
      link.download = file.fileName;
      link.click();
      this.loading = false;
    });
  }
}
